// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__QXIMq","btn":"styles_btn__13BTW","tags":"styles_tags__21Xxh"};